"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, // database to virtual relation and create an index for it
"default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _models = require("~/models");
const _getUniqueName = require("~/helpers/getUniqueName");
const _getColumnPropsFromUIDT = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnPropsFromUIDT"));
const _ProjectMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/v2/ProjectMgrv2"));
const _columnsservice = require("~/services/columns.service");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _getColumnUiType = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnUiType"));
const _RequestQueue = /*#__PURE__*/ _interop_require_default(require("~/utils/RequestQueue"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// An upgrader for upgrading created_at and updated_at columns
// to system column and convert to new uidt CreatedTime and LastModifiedTime
const logger = {
    log: (message)=>{
        console.log(`[ncXcdbCreatedAndUpdatedSystemFieldsUpgrader ${Date.now()}] ` + message);
    },
    error: (message)=>{
        console.error(`[ncXcdbCreatedAndUpdatedSystemFieldsUpgrader ${Date.now()}] ` + message);
    }
};
/* Enable if planning to remove trigger
async function deletePgTrigger({
  column,
  ncMeta,
  model,
}: {
  ncMeta: MetaService;
  column: Column;
  model: Model;
}) {
  // delete pg trigger
  const triggerFnName = `xc_au_${model.table_name}_${column.column_name}`;
  const triggerName = `xc_trigger_${model.table_name}_${column.column_name}`;

  await ncMeta.knex.raw(`DROP TRIGGER IF EXISTS ?? ON ??;`, [
    triggerName,
    model.table_name,
  ]);
  await ncMeta.knex.raw(`DROP FUNCTION IF EXISTS ??()`, [triggerFnName]);
}
*/ async function upgradeModels({ ncMeta, source, base, models }) {
    const context = {
        workspace_id: base.fk_workspace_id,
        base_id: base.id
    };
    // get existing columns from database
    const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source, ncMeta.knex);
    const sqlMgr = _ProjectMgrv2.default.getSqlMgr(context, {
        id: source.base_id
    }, ncMeta);
    await Promise.all(models.map(async (model)=>{
        if (model.mm) return;
        try {
            var _data_list, _data, _this, _source_getConfig;
            const columns = model.columns;
            const oldColumns = columns.map((c)=>_extends({}, c, {
                    cn: c.column_name
                }));
            let isCreatedTimeExists = false;
            let isLastModifiedTimeExists = false;
            let isCreatedByExists = false;
            let isLastModifiedByExists = false;
            for (const column of columns){
                if (![
                    _nocodbsdk.UITypes.DateTime,
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.CreatedBy,
                    _nocodbsdk.UITypes.LastModifiedBy
                ].includes(column.uidt)) continue;
                if (column.uidt === _nocodbsdk.UITypes.CreatedBy && column.system) {
                    isCreatedByExists = true;
                    continue;
                }
                if (column.uidt === _nocodbsdk.UITypes.LastModifiedBy && column.system) {
                    isLastModifiedByExists = true;
                    continue;
                }
                if ([
                    _nocodbsdk.UITypes.CreatedBy,
                    _nocodbsdk.UITypes.LastModifiedBy
                ].includes(column.uidt)) {
                    continue;
                }
                if (column.uidt === _nocodbsdk.UITypes.CreatedTime && column.system) {
                    isCreatedTimeExists = true;
                    continue;
                }
                if (column.uidt === _nocodbsdk.UITypes.LastModifiedTime && column.system) {
                    isLastModifiedTimeExists = true;
                    continue;
                }
                // if column is created_at or updated_at, update the uidt in meta
                if (column.column_name === 'created_at') {
                    isCreatedTimeExists = true;
                    if (column.uidt !== _nocodbsdk.UITypes.CreatedTime || !column.system) {
                        await _models.Column.update(context, column.id, _extends({}, column, {
                            uidt: _nocodbsdk.UITypes.CreatedTime,
                            system: true
                        }), ncMeta, true);
                    }
                /*   Enable if planning to remove trigger
          if (source.type === 'pg') {
            // delete pg trigger if exists
            await deletePgTrigger({ column, ncMeta, model });
          }
          */ }
                if (column.column_name === 'updated_at') {
                    isLastModifiedTimeExists = true;
                    if (column.uidt !== _nocodbsdk.UITypes.LastModifiedTime || !column.system) {
                        await _models.Column.update(context, column.id, _extends({}, column, {
                            uidt: _nocodbsdk.UITypes.LastModifiedTime,
                            system: true
                        }), ncMeta, true);
                    }
                }
            }
            if (isCreatedTimeExists && isLastModifiedTimeExists && isCreatedByExists && isLastModifiedByExists) {
                return;
            }
            const dbColumns = ((_this = await sqlClient.columnList({
                tn: model.table_name,
                schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
            })) == null ? void 0 : (_data = _this.data) == null ? void 0 : (_data_list = _data.list) == null ? void 0 : _data_list.map((c)=>_extends({}, c, {
                    column_name: c.cn
                }))) || [];
            // if no columns found skip since table might not be there
            if (!dbColumns.length) {
                logger.log(`Skipping upgrade of model '${model.title}'(${model.id}) from base '${base.title}'(${base.id}}) since columns not found`);
                return;
            }
            // create created_at & updated_at and created_by & updated_by columns
            const newColumns = [];
            const existingDbColumns = [];
            if (!isCreatedTimeExists) {
                // check column exist and add to meta if found
                const columnName = (0, _getUniqueName.getUniqueColumnName)(columns, 'created_at');
                const dbColumn = dbColumns.find((c)=>c.cn === columnName);
                // if column already exist, just update the meta
                if (dbColumn && (0, _getColumnUiType.default)(source, dbColumn) === _nocodbsdk.UITypes.DateTime) {
                    existingDbColumns.push(_extends({}, dbColumn, {
                        uidt: _nocodbsdk.UITypes.CreatedTime,
                        column_name: columnName,
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'CreatedAt'),
                        system: true
                    }));
                } else {
                    newColumns.push(_extends({}, await (0, _getColumnPropsFromUIDT.default)({
                        uidt: _nocodbsdk.UITypes.CreatedTime,
                        column_name: (0, _getUniqueName.getUniqueColumnName)([
                            ...columns,
                            ...dbColumns
                        ], 'created_at'),
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'CreatedAt')
                    }, source), {
                        cdf: null,
                        system: true,
                        altered: _columnsservice.Altered.NEW_COLUMN
                    }));
                }
            }
            if (!isLastModifiedTimeExists) {
                const columnName = (0, _getUniqueName.getUniqueColumnName)(columns, 'created_at');
                const dbColumn = dbColumns.find((c)=>c.cn === columnName);
                // if column already exist, just update the meta
                if (dbColumn && (0, _getColumnUiType.default)(source, dbColumn) === _nocodbsdk.UITypes.DateTime) {
                    existingDbColumns.push(_extends({
                        uidt: _nocodbsdk.UITypes.LastModifiedTime
                    }, dbColumn, {
                        column_name: columnName,
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'UpdatedAt'),
                        system: true
                    }));
                } else {
                    newColumns.push(_extends({}, await (0, _getColumnPropsFromUIDT.default)({
                        uidt: _nocodbsdk.UITypes.LastModifiedTime,
                        column_name: (0, _getUniqueName.getUniqueColumnName)([
                            ...columns,
                            ...dbColumns
                        ], 'updated_at'),
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'UpdatedAt')
                    }, source), {
                        cdf: null,
                        system: true,
                        altered: _columnsservice.Altered.NEW_COLUMN
                    }));
                }
            }
            if (!isCreatedByExists) {
                const columnName = (0, _getUniqueName.getUniqueColumnName)(columns, 'created_by');
                const dbColumn = dbColumns.find((c)=>c.cn === columnName);
                // if column already exist in db but not in meta, just update the meta (partial upgraded case)
                if (dbColumn) {
                    existingDbColumns.push(_extends({
                        uidt: _nocodbsdk.UITypes.CreatedBy
                    }, dbColumn, {
                        column_name: columnName,
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'nc_created_by'),
                        system: true
                    }));
                } else {
                    newColumns.push(_extends({}, await (0, _getColumnPropsFromUIDT.default)({
                        uidt: _nocodbsdk.UITypes.CreatedBy,
                        column_name: (0, _getUniqueName.getUniqueColumnName)([
                            ...columns,
                            ...dbColumns
                        ], 'created_by'),
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'nc_created_by')
                    }, source), {
                        cdf: null,
                        system: true,
                        altered: _columnsservice.Altered.NEW_COLUMN
                    }));
                }
            }
            if (!isLastModifiedByExists) {
                const columnName = (0, _getUniqueName.getUniqueColumnName)(columns, 'updated_by');
                const dbColumn = dbColumns.find((c)=>c.cn === columnName);
                // if column already exist in db but not in meta, just update the meta (partial upgraded case)
                if (dbColumn) {
                    existingDbColumns.push(_extends({
                        uidt: _nocodbsdk.UITypes.LastModifiedBy
                    }, dbColumn, {
                        column_name: columnName,
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'nc_updated_by'),
                        system: true
                    }));
                } else {
                    newColumns.push(_extends({}, await (0, _getColumnPropsFromUIDT.default)({
                        uidt: _nocodbsdk.UITypes.LastModifiedBy,
                        column_name: (0, _getUniqueName.getUniqueColumnName)([
                            ...columns,
                            ...dbColumns
                        ], 'updated_by'),
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(columns, 'nc_updated_by')
                    }, source), {
                        cdf: null,
                        system: true,
                        altered: _columnsservice.Altered.NEW_COLUMN
                    }));
                }
            }
            // alter table and add new columns if any
            if (newColumns.length) {
                // update column in db
                const tableUpdateBody = _extends({}, model, {
                    tn: model.table_name,
                    originalColumns: oldColumns,
                    columns: [
                        ...columns,
                        ...newColumns
                    ].map((c)=>_extends({}, c, {
                            cn: c.column_name
                        }))
                });
                await sqlMgr.sqlOpPlus(source, 'tableUpdate', tableUpdateBody);
            }
            for (const newColumn of [
                ...existingDbColumns,
                ...newColumns
            ]){
                await _models.Column.insert(context, _extends({}, newColumn, {
                    system: true,
                    fk_model_id: model.id
                }), ncMeta);
            }
        } catch (e) {
            logger.error(`Upgrading model '${model.title}'(${model.id}) from base '${base.title}'(${base.id}}) failed`);
            throw e;
        }
    }));
}
async function _default({ ncMeta }) {
    // get all xcdb sources
    const sources = await ncMeta.knexConnection(_globals.MetaTable.SOURCES).condition({
        _or: [
            {
                is_meta: {
                    eq: 1
                }
            },
            ..._Noco.default.isEE() ? [
                {
                    is_local: {
                        eq: 1
                    }
                }
            ] : []
        ]
    });
    const requestQueue = new _RequestQueue.default();
    // iterate and upgrade each base
    await Promise.all(sources.map(async (_source, i)=>{
        const source = new _models.Source(_source);
        const context = {
            workspace_id: source.fk_workspace_id,
            base_id: source.base_id
        };
        const base = await source.getProject(context, ncMeta);
        // skip deleted base bases
        if (!base || base.deleted) {
            logger.log(`Skipped deleted base source '${source.alias || source.id}' - ${base == null ? void 0 : base.id}`);
            return Promise.resolve();
        }
        // update the meta props
        return requestQueue.enqueue(async ()=>{
            const models = await _models.Model.list(context, {
                base_id: source.base_id,
                source_id: source.id
            }, ncMeta);
            for (const model of models){
                await model.getColumns(context, ncMeta);
            }
            logger.log(`Upgrading base ${base.title}(${base.id},${source.id}) (${i + 1}/${sources.length})`);
            await upgradeModels({
                ncMeta,
                source,
                models,
                base
            }).then(()=>{
                logger.log(`Upgraded base '${base.title}'(${base.id},${source.id}) (${i + 1}/${sources.length})`);
            });
        });
    }));
}
